const $ = require('jquery');

$('.js-downloadFullPDF').click(function()
{
  let $button = $(this);

  let reportCategory = $button.attr('data-report-category');
  let reportYear = $button.attr('data-report-year');
  let reportName = $button.attr('data-report-name');
  let reportLocale = $button.attr('data-report-locale');
  // console.log(reportCategory, reportYear, reportName, reportLocale);
  dataLayer.push({'event':'interaction', 'reportCategory': reportCategory, 'reportName': reportName, 'reportYear': reportYear, 'reportLocale': reportLocale, 'reportAction': 'download-full-report'});
});